import moment from 'moment'

import { parseExtendedTime } from './extendedTimeUtils'

const parseCsvInteger = value => {
  if (value == null || value === '') return undefined
  const trimmed = String(value).trim()
  if (!/^-?\d+$/.test(trimmed)) return undefined
  return Number(trimmed)
}

const parseCsvBoolean = value => ['TRUE', 'true', '1', true, 1].includes(value)

const parseIsPublished = value => {
  if (value == null || value === '') return true
  if (['TRUE', 'true', '1', '掲載'].includes(value)) return true
  if (['FALSE', 'false', '0', '未掲載'].includes(value)) return false
  return undefined
}

const parseIsDoubleRecruitment = value => {
  if (value == null || value === '') return false
  if (['TRUE', 'true', '1', '二診目'].includes(value)) return true
  if (['FALSE', 'false', '0'].includes(value)) return false
  return undefined
}

const parseSubsidyMoney = value => {
  if (value == null || value === '') return undefined
  const trimmed = String(value).trim()
  if (!/^\d+$/.test(trimmed)) return undefined
  return Number(trimmed)
}

const parseSubsidyTitle = value => {
  if (value == null || value === '') return undefined
  return value
}

const convertUserCsvRecord = data =>
  data.map(record => {
    const {
      email,
      date: rowDate,
      startTime,
      endTime,
      splitDateTime1,
      splitDateTime2,
      splitDateTime3,
      hourlyWage,
      splitHourlyWage1,
      splitHourlyWage2,
      splitHourlyWage3,
      comment,
      isStartTimeBreakTime,
      isSplitDateTime1BreakTime,
      isSplitDateTime2BreakTime,
      isSplitDateTime3BreakTime,
      numberOfRooms,
      departmentCode,
      delete: isDelete,
      isPublished,
      isDoubleRecruitment,
    } = record
    const rowMomentDate = moment(rowDate, ['YYYY-MM-DD', 'YYYY/MM/DD'], true)
    return {
      numberOfRooms: parseCsvInteger(numberOfRooms),
      email,
      departmentCode,
      startTime: startTime
        ? parseExtendedTime(rowMomentDate, startTime)
        : undefined,
      endTime: endTime ? parseExtendedTime(rowMomentDate, endTime) : undefined,
      hourlyWage: parseCsvInteger(hourlyWage),
      splitDateTime1: splitDateTime1
        ? parseExtendedTime(rowMomentDate, splitDateTime1)
        : undefined,
      splitDateTime2: splitDateTime2
        ? parseExtendedTime(rowMomentDate, splitDateTime2)
        : undefined,
      splitDateTime3: splitDateTime3
        ? parseExtendedTime(rowMomentDate, splitDateTime3)
        : undefined,
      isStartTimeBreakTime: parseCsvBoolean(isStartTimeBreakTime),
      isSplitDateTime1BreakTime: parseCsvBoolean(isSplitDateTime1BreakTime),
      isSplitDateTime2BreakTime: parseCsvBoolean(isSplitDateTime2BreakTime),
      isSplitDateTime3BreakTime: parseCsvBoolean(isSplitDateTime3BreakTime),
      splitHourlyWage1: parseCsvInteger(splitHourlyWage1),
      splitHourlyWage2: parseCsvInteger(splitHourlyWage2),
      splitHourlyWage3: parseCsvInteger(splitHourlyWage3),
      comment: comment || undefined,
      isDelete: isDelete === '1',
      isPublished: parseIsPublished(isPublished),
      isDoubleRecruitment: parseIsDoubleRecruitment(isDoubleRecruitment),
      doctorSubsidy1Title: parseSubsidyTitle(record.doctorSubsidy1Title),
      doctorSubsidy1Money: parseSubsidyMoney(record.doctorSubsidy1Money),
      doctorSubsidy2Title: parseSubsidyTitle(record.doctorSubsidy2Title),
      doctorSubsidy2Money: parseSubsidyMoney(record.doctorSubsidy2Money),
      doctorSubsidy3Title: parseSubsidyTitle(record.doctorSubsidy3Title),
      doctorSubsidy3Money: parseSubsidyMoney(record.doctorSubsidy3Money),
      doctorSubsidy4Title: parseSubsidyTitle(record.doctorSubsidy4Title),
      doctorSubsidy4Money: parseSubsidyMoney(record.doctorSubsidy4Money),
      doctorSubsidy5Title: parseSubsidyTitle(record.doctorSubsidy5Title),
      doctorSubsidy5Money: parseSubsidyMoney(record.doctorSubsidy5Money),
    }
  })
export default convertUserCsvRecord
